// src/stores/index.js
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useStore = defineStore(
	'main',
	() => {
		// ====== 初始化狀態 ======
		const isLoading = ref(true)
		const loadingTitle = ref('加載中')
		const loadingMessage = ref('請稍候...')

		const setLoading = (isLoaded, title = '加載中', message = '請稍候...') => {
			isLoading.value = isLoaded
			loadingTitle.value = title
			loadingMessage.value = message
		}

		const stopLoading = () => {
			isLoading.value = false
		}

		const alertModal = ref(null)

		// 設置 AlertModal 的 ref（在 App.vue 中調用）
		const setAlertRef = (ref) => {
			alertModal.value = ref
		}

		// 顯示 Alert 的通用方法
		const showAlert = (type = '', message = '', data = {}, confirmCallback = null, cancelCallback = null) => {
			if (alertModal.value) {
				alertModal.value.show(type, message, data, confirmCallback, cancelCallback)
			} else {
				console.warn('❌ AlertModal 尚未初始化')
			}
		}

		// ====== LINE LIFF 相關 ======
		const profile = ref(null)
		const userId = ref(null)
		const displayName = ref(null)
		const pageName = ref(null)
		const token = ref(null)
		const shareUID = ref(null)

		// 記錄路由位置
		const previousRoutePath = ref(null)
		const isReady = ref(false)

		// ======= 使用者選擇狀態 ======
		const timeStatus = ref(null) // 是否超過活動時間
		const selectedGender = ref(null)
		const selectedPhoto = ref(null) //上傳照片
		const selectedMusic = ref(null) //選擇的音樂

		const resetSelect = () => {
			selectedGender.value = null
			selectedPhoto.value = null
			selectedMusic.value = null
		}

		// ====== Actions ======
		const resetAll = async () => {
			isLoading.value = true
			isReady.value = false

			profile.value = null
			userId.value = null
			displayName.value = null
			pageName.value = null
			token.value = null

			timeStatus.value = null
			selectedGender.value = null 
			selectedPhoto.value = null
			selectedMusic.value = null

			return Promise.resolve(true)
		}

		// 頁面名稱
		const setPageName = (page) => {
			pageName.value = page
		}
		// 分享者的ID 分享連結帶進來的
		const setShareUID = (id) => {
			shareUID.value = id
		}

		const setIsReady = (value) => {
			isReady.value = value
		}

		//
		const setToken = (id) => {
			token.value = id
		}

		const setprofile = async (profileData) => {
			profile.value = profileData
			userId.value = profileData.userId
			displayName.value = profileData.displayName
			return Promise.resolve(true)
		}

		const setSelectedGender = (gender) => {
			selectedGender.value = gender
		}

		const setPreviousRout = (path) => {
			previousRoutePath.value = path
		}
		const setPhotoUpLoad = (photo) => {
			selectedPhoto.value = photo
		}

		const setSelectedMusic = (music) => {
			selectedMusic.value = music
		}

		const setTimeStatus = (state) => {
			timeStatus.value = state
		}


		return {
			isLoading,
			loadingTitle,
			loadingMessage,
			stopLoading,
			setLoading,

			alertModal,
			setAlertRef,
			showAlert,

			isReady,
			setIsReady,

			pageName,
			setPageName,

			shareUID,
			setShareUID,

			resetAll,
			resetSelect,

			profile,
			setprofile,
			userId,
			displayName,

			token,
			setToken,

			selectedGender,
			setSelectedGender,

			previousRoutePath,
			setPreviousRout,

			selectedPhoto,
			setPhotoUpLoad,
			selectedMusic,
			setSelectedMusic,

			timeStatus,
			setTimeStatus,
		}
	},
	{
		persist: {
			// isLoading 不 persist，每次開啟都從 true 開始，避免 LIFF redirect 閃爍
			paths: ['profile', 'userId', 'displayName', 'token', 'shareUID', 'selectedMusic', 'selectedGender']
		}
	}
)
